import { useQuery } from "@tanstack/react-query";
import { ICota } from ".";
import { genericGet } from "../../../../../../services/api.service";
import { MenuItem, Select } from "@mui/material";



export function Amostragem({ cota, updateAmostragens, addAmostragem, updateCota }: {
    cota: ICota,
    updateAmostragens: (internalId: number, idx: number, value: number) => void,
    addAmostragem: (internalId: number) => void,
    updateCota: (n: number, cota: Partial<ICota>) => void
}) {

    const { data: dispositivisMedicao } = useQuery({
        queryKey: ['dispositivo'],
        queryFn: async () => {
            return (await genericGet(`/dispositivo-medicao?page=1&take=1000`)).data;
        },
        onSuccess: (data) => console.log("Received: ", data),
    });

    const amostraNotOk = (valor: number) => {
        return valor > cota.valor + cota.intervaloDeTolerancia?.positiva || valor < cota.valor - cota.intervaloDeTolerancia?.negativa
    }

    const estado = () => {
        let amostragensFora = 0;
        let notFinished = false;
        cota.amostragens.map((c: { valor: number }) => {
            if (!c.valor) {
                notFinished = true;
                return;
            }
            if (c.valor > cota.valor + cota.intervaloDeTolerancia?.positiva || c.valor < cota.valor - cota.intervaloDeTolerancia?.negativa) amostragensFora++;
        })

        if (notFinished) return null;

        if (Math.ceil((amostragensFora / cota.amostragens.length) * 100) >= 20) return 'NOK';

        return 'OK';
    }

    return (
        <div className="flex w-full justify-between p-2 py-1 items-center border rounded mb-2">
            <div className="flex items-center">
                <div className="bg-cyan-600 rounded-l flex flex-col h-44">
                    <h1 className="text-xl ml-6 mr-6 w-6 flex items-center text-[2.2em] font-black h-full">{cota.number}</h1>
                </div>
                <div className="px-6 bg-gray-400 rounded-r h-44 flex flex-col justify-center">
                    <div className="flex">
                        <div className="flex items-center mb-4">
                            <div className="mr-2">Cota nominal</div>
                            <div className="p-2 bg-gray-300 rounded">
                                <input
                                    type="number"
                                    className="border border-solid rounded-md mr-6 w-24 remove-arrow"
                                    value={cota.valor}
                                    onChange={(e) => updateCota(cota.internalId, { valor: parseFloat(e.target.value) })}
                                />
                            </div>
                        </div>

                        <Select
                            className="bg-white w-48 h-10 ml-3"
                            value={cota?.dispositivoMedicao}
                            renderValue={(v) => v ? `${v?.designacao}-${v?.referencia}` : ""}
                            onChange={(e : any) => { 
                                updateCota(cota.internalId, { dispositivoMedicao: e.target.value }) }}
                            // label={options.name}
                            labelId={"input-id"}>
                            {dispositivisMedicao?.length ? dispositivisMedicao.map((l: any, idx: number) => {
                                return <MenuItem key={idx} value={l} >{`${l.designacao} - ${l.referencia}`}</MenuItem>
                            }) : null}
                        </Select>
                    </div>

                    <div className="flex items-center mb-4 ">
                        <div className="mr-4">Intervalo de tolerâncias</div>
                        <div className="flex items-center p-2 bg-gray-300 rounded mr-2">
                            <div className="mr-2 text-[1.5em] leading-none font-black">-</div>
                            <input
                                type="number"
                                value={cota.intervaloDeTolerancia?.negativa}
                                className="border border-solid rounded-md w-24 remove-arrow"
                                onChange={(e) => updateCota(cota.internalId, {
                                    intervaloDeTolerancia: {
                                        ...cota.intervaloDeTolerancia,
                                        negativa: parseFloat(e.target.value)
                                    }
                                })}
                            />
                        </div>
                        <div className="flex items-center p-2 bg-gray-300 rounded mr-2">
                            <div className="mr-2 text-[1.5em] leading-none font-black">+</div>
                            <input
                                type="number"
                                className="border border-solid rounded-md  w-24 remove-arrow"
                                value={cota.intervaloDeTolerancia?.positiva}
                                onChange={(e) => updateCota(cota.internalId, {
                                    intervaloDeTolerancia: {
                                        ...cota.intervaloDeTolerancia,
                                        positiva: parseFloat(e.target.value)
                                    }
                                })} />
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="flex justify-start w-full items-center">
                            <div className="mr-3">Medições</div>

                            {cota?.amostragens?.sort((a, b) => a.numero < b.numero ? 0 : 1)?.map((m, idx) => <div className={`flex items-center p-2 ${m.valor != 0 ? amostraNotOk(m.valor) ? 'bg-red-500' : 'bg-green-500' : 'bg-gray-300'}  rounded mr-2`}>
                                <div className="mr-2 font-bold">{m.numero}</div><input
                                    type="number"
                                    onChange={(e) => updateAmostragens(cota.internalId, idx, parseFloat(e.target.value))}
                                    className="border border-solid rounded-md  w-24"
                                    value={m.valor}
                                /></div>)}
                        </div>
                        {/* <div className="flex justify-center items-center border p-2 py-0 rounded-md cursor-pointer" onClick={() => addAmostragem(cota.internalId)}>
                            <div className="text-xl font-bold">+</div>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* <div className="flex ">
                <div >Desvio padrão: {0}</div>
            </div> */}
            <div className={`flex flex-col h-full mr-5`}>
                {estado() ?
                    <div className={`${estado() === 'OK' ? 'bg-green-500' : 'bg-red-500'} flex justify-center py-5 w-24 text-[2em] font-black rounded-md`}>
                        {estado()}
                    </div> :
                    <div className={`bg-amber-500 flex justify-center py-5 w-24 text-[2em] font-black rounded-md`}>?</div>
                }

            </div>

        </div>
    )


}